/** What moved the stock behind a cost consumption row, as reports show it. */
export const COST_MOVEMENTS = [
  "sale",
  "return",
  "write-off",
  "build",
  "count",
  "adjustment",
  "reversal",
  "true-up",
  "realignment",
  "opening balance",
] as const;

export type CostMovement = (typeof COST_MOVEMENTS)[number];
